import React from 'react';
import { MODE_COMPARISON } from '../ruach';

export default function ModeComparisonModal({ onClose, mode }) {
  const isRuach = mode === 'ruach';

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: 300,
        background: 'rgba(0,0,0,0.8)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: '1.5rem',
        backdropFilter: 'blur(8px)',
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          width: '100%', maxWidth: '720px', maxHeight: '85vh',
          background: '#0a0c14',
          border: `1px solid ${isRuach ? 'rgba(255,160,60,0.25)' : 'rgba(240,192,64,0.25)'}`,
          borderRadius: '16px', overflow: 'hidden',
          display: 'flex', flexDirection: 'column',
          animation: 'modalIn 0.2s ease-out',
        }}
      >
        <style>{`@keyframes modalIn { from { opacity:0; transform: scale(0.96) translateY(12px); } to { opacity:1; transform: scale(1) translateY(0); } }`}</style>

        {/* Header */}
        <div style={{
          padding: '1.5rem 1.75rem',
          borderBottom: `1px solid ${isRuach ? 'rgba(255,160,60,0.15)' : 'rgba(240,192,64,0.15)'}`,
          display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between',
          flexShrink: 0,
        }}>
          <div>
            <div style={{
              fontSize: '0.65rem', fontFamily: 'Space Mono, monospace',
              letterSpacing: '0.12em', textTransform: 'uppercase',
              color: isRuach ? '#ffb060' : '#f0c040', marginBottom: '0.4rem',
            }}>
              Two lenses — one reality
            </div>
            <h2 style={{ fontFamily: 'Syne, sans-serif', fontWeight: 700, fontSize: '1.4rem', color: '#fff', margin: 0 }}>
              What changes between modes
            </h2>
            <p style={{ fontSize: '0.8rem', color: 'rgba(255,255,255,0.4)', marginTop: '0.4rem', margin: '0.4rem 0 0' }}>
              The physics never changes. Only the language and the framing.
            </p>
          </div>
          <button
            onClick={onClose}
            style={{
              background: 'none', border: '1px solid rgba(255,255,255,0.15)',
              color: 'rgba(255,255,255,0.5)', cursor: 'pointer', borderRadius: '6px',
              width: '32px', height: '32px', fontSize: '1.1rem',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              flexShrink: 0,
            }}
          >×</button>
        </div>

        {/* Column headers */}
        <div style={{
          display: 'grid', gridTemplateColumns: '1fr 1fr 1fr',
          padding: '0.75rem 1.75rem',
          borderBottom: '1px solid rgba(255,255,255,0.06)',
          flexShrink: 0,
        }}>
          {['Science · Higgs', 'Ruach · רוּחַ', 'Scripture'].map((h, i) => (
            <div key={h} style={{
              fontSize: '0.62rem', fontFamily: 'Space Mono, monospace',
              textTransform: 'uppercase', letterSpacing: '0.1em',
              color: i === 0 ? '#f0c040' : i === 1 ? '#ffb060' : 'rgba(255,255,255,0.25)',
            }}>{h}</div>
          ))}
        </div>

        {/* Rows */}
        <div style={{ overflowY: 'auto', flex: 1 }}>
          {MODE_COMPARISON.map((row, i) => (
            <div
              key={i}
              style={{
                display: 'grid', gridTemplateColumns: '1fr 1fr 1fr',
                padding: '0.875rem 1.75rem',
                borderBottom: '1px solid rgba(255,255,255,0.04)',
                background: i % 2 === 0 ? 'transparent' : 'rgba(255,255,255,0.02)',
                transition: 'background 0.1s',
              }}
            >
              <div style={{ fontSize: '0.82rem', color: 'rgba(255,255,255,0.7)', paddingRight: '1rem' }}>
                {row.science}
              </div>
              <div style={{ fontSize: '0.82rem', color: '#ffb060', paddingRight: '1rem', lineHeight: 1.5 }}>
                {row.ruach}
              </div>
              <div style={{ fontSize: '0.75rem', color: 'rgba(255,255,255,0.3)', fontStyle: 'italic', lineHeight: 1.5 }}>
                {row.scripture}
              </div>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div style={{
          padding: '1rem 1.75rem',
          borderTop: '1px solid rgba(255,255,255,0.06)',
          fontSize: '0.75rem', color: 'rgba(255,255,255,0.3)',
          lineHeight: 1.65, flexShrink: 0,
        }}>
          "For since the creation of the world God's invisible qualities — his eternal power and divine nature — have been clearly seen, being understood from what has been made." — Romans 1:20
        </div>
      </div>
    </div>
  );
}
